<script setup lang="ts">
import { ArrowUpRight, CheckCircle2 } from "lucide-vue-next";
import "@/assets/styles/about.css";
import aboutImg from "@/assets/images/about-garden.png";
</script>

<template>
  <section class="about-section" id="about">
    <div class="section-shell about-grid">
      <div class="about-visual reveal">
        <img :src="aboutImg" alt="Professionell gestaltete Außenanlage" />
        <div class="image-caption"><span>Planung</span><span>Ausführung</span><span>Pflege</span></div>
      </div>
      <div class="about-copy reveal">
        <span class="eyebrow">Freiraum beginnt mit Weitblick</span>
        <h2>Außenanlagen sind mehr als <em>schönes Grün.</em></h2>
        <p class="lead">Sie sind Empfang, Aufenthaltsort und Visitenkarte. Deshalb verbinden wir Gestaltung mit Handwerk und denken jedes Projekt vom Alltag seiner Nutzer her.</p>
        <div class="about-points">
          <div><CheckCircle2 /><span><strong>Ein Ansprechpartner</strong><small>Von der Idee bis zur Abnahme</small></span></div>
          <div><CheckCircle2 /><span><strong>Planbar & transparent</strong><small>Klare Abläufe, saubere Kommunikation</small></span></div>
          <div><CheckCircle2 /><span><strong>Langfristig gedacht</strong><small>Robuste Lösungen und passende Pflege</small></span></div>
        </div>
        <a href="#contact" class="text-link">Lernen Sie uns kennen <ArrowUpRight :size="18" /></a>
      </div>
    </div>
  </section>
</template>
